import React from 'react'
import { DocLayout } from './DocLayout'

export function PageWrapper({
  children,
  props: {
    data: { mdx },
  },
}) {
  if (!mdx?.fields?.pageType) return children
  switch (mdx.fields.pageType) {
    case 'doc':
    case 'page':
      return (
        <DocLayout
          title={mdx.fields.title}
          tableOfContents={mdx.tableOfContents}
          editLink={mdx.fields.editLink}
        >
          {children}
        </DocLayout>
      )
    default:
      return children
  }
}
